import { render, staticRenderFns } from "./MSSkills.vue?vue&type=template&id=0dd0dac0&scoped=true&"
import script from "./MSSkills.vue?vue&type=script&lang=js&"
export * from "./MSSkills.vue?vue&type=script&lang=js&"
import style0 from "./MSSkills.vue?vue&type=style&index=0&id=0dd0dac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd0dac0",
  null
  
)

export default component.exports